import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../api';
import s from './LoginPage.module.scss';

export default function LoginPage() {
    const navigate = useNavigate();
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [retryAfter, setRetryAfter] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (loading) return;
        setError('');
        setRetryAfter(null);
        setLoading(true);
        try {
            const { data } = await api.post('/admin/login', { login, password });
            localStorage.setItem('admin_token', data.access_token);
            navigate('/', { replace: true });
        } catch (err) {
            if (err.response?.status === 429) {
                const retry = err.response.headers['retry-after'];
                setRetryAfter(retry ? Math.ceil(Number(retry) / 60) : 5);
                setError('Слишком много попыток входа. Попробуйте позже.');
            } else if (err.response?.status === 401) {
                setError('Неверный логин или пароль');
            } else if (err.response?.status === 503) {
                setError('Административный доступ не настроен на сервере');
            } else {
                setError('Ошибка подключения к серверу');
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={s.page}>
            <div className={s.card}>
                <div className={s.logo}>
                    <span className={s.wordmark}>
                        Resume<span className={s.bracket}>[</span>Scan<span className={s.bracket}>]</span>
                    </span>
                </div>

                <h1 className={s.title}>Вход в панель управления</h1>

                <form className={s.form} onSubmit={handleSubmit}>
                    <div className={s.field}>
                        <label className={s.label}>Логин</label>
                        <input
                            className={s.input}
                            type="text"
                            value={login}
                            onChange={e => setLogin(e.target.value)}
                            placeholder="admin"
                            autoComplete="username"
                            autoFocus
                        />
                    </div>
                    <div className={s.field}>
                        <label className={s.label}>Пароль</label>
                        <input
                            className={s.input}
                            type="password"
                            value={password}
                            onChange={e => setPassword(e.target.value)}
                            placeholder="••••••••"
                            autoComplete="current-password"
                        />
                    </div>

                    {error && (
                        <div className={s.error}>
                            {error}
                            {retryAfter && <span className={s.retryHint}> (~{retryAfter} мин)</span>}
                        </div>
                    )}

                    <button
                        className={s.btn}
                        type="submit"
                        disabled={loading || !login || !password}
                    >
                        {loading ? <span className={s.spinner} /> : 'Войти'}
                    </button>
                </form>
            </div>
        </div>
    );
}
